var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowToUse1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 236,
    viewBox: "0 0 356 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2524_98293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 280,
    height: 160,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 30,
    width: 221.4,
    height: 86.4,
    rx: 9,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3999,
    y: 44.4004,
    width: 57.6,
    height: 57.6,
    rx: 1.8,
    fill: "#F3F4F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 44.4004,
    width: 127.8,
    height: 10.8,
    rx: 0.9,
    fill: "#E5E7EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 62.4004,
    width: 127.8,
    height: 7.2,
    rx: 0.9,
    fill: "#E5E7EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 76.8003,
    width: 127.8,
    height: 7.2,
    rx: 0.9,
    fill: "#E5E7EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 96.6006,
    width: 39.6,
    height: 5.4,
    rx: 1.8,
    fill: "#B2DDFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 96.6006,
    width: 39.6,
    height: 5.4,
    rx: 1.8,
    fill: "#B2DDFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 30,
    width: 221.4,
    height: 86.4,
    rx: 9,
    stroke: "#E5E7EB",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 60,
    width: 246,
    height: 96,
    rx: 10,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 76,
    width: 64,
    height: 64,
    rx: 2,
    fill: "#F3F4F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 76,
    width: 142,
    height: 12,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 96,
    width: 142,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 112,
    width: 142,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 134,
    width: 44,
    height: 6,
    rx: 2,
    fill: "#B2DDFF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 134,
    width: 44,
    height: 6,
    rx: 2,
    fill: "#B2DDFF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 60,
    width: 246,
    height: 96,
    rx: 10,
    stroke: "#53B1FD",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2524_98293",
    x: 0,
    y: 0,
    width: 356,
    height: 236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2524_98293"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2524_98293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2524_98293",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUse1);
export default __webpack_public_path__ + "static/media/how_to_use_1.b0f4fbf858300b22f81413439a959349.svg";
export { ForwardRef as ReactComponent };